import ModalAddEditTermCategory from "./modal-add-edit-term-category";

export default ModalAddEditTermCategory;